import type { Components, Theme } from '@mui/material/styles'

declare module '@mui/material/Avatar' {
  interface AvatarPropsVariantOverrides {
    orgCard: true
    userAvatar: true
    compactAvatar: true
    titleIcon: true
  }
}

export const MuiAvatarOverride: Components<Theme>['MuiAvatar'] = {
  variants: [
    {
      props: { variant: 'userAvatar' },
      style: ({ theme }) => ({
        width: 44,
        height: 44,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: '0.875rem',
      }),
    },
    {
      // Holds a page-title icon in a brand-blue circle. The icon sits at roughly
      // half the diameter so the circle reads as a badge rather than a button.
      props: { variant: 'titleIcon' },
      style: ({ theme }) => ({
        width: 44,
        height: 44,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
          fontSize: 22,
        },
      }),
    },
    {
      props: { variant: 'compactAvatar' },
      style: ({ theme }) => ({
        width: 32,
        height: 32,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: '0.75rem',
        flexShrink: 0,
      }),
    },
    {
      props: { variant: 'orgCard' },
      style: ({ theme }) => ({
        width: 48,
        height: 48,
        borderRadius: 2,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.secondary,
        fontWeight: 600,
        fontSize: '1.125rem',
        transition: 'background-color 0.2s ease, color 0.2s ease',
        flexShrink: 0,
      }),
    },
  ],
}
